import { UserProfileTheme } from '@prisma/client';

const THEME_STORAGE_KEY = 'colorTheme';

const THEME_OPTIONS = Object.values(UserProfileTheme).map(colorMode => ({ label: colorMode, value: colorMode }));

export { THEME_OPTIONS, THEME_STORAGE_KEY };
